export const ACS_UOM_OPTIONS: string[] = ['BU', 'CW', 'GL', 'LB', 'MT', 'ST'];

export const ACS_GROUP_PREFIX = 'G-';
export const ACS_WILDCARD = '*';
export const ACS_BILLING_ADDRESS_KEY = 'BillingAddress';
export const ACS_HTTP_CONFLICT = 409;
export const ACS_TOAST_SUCCESS_DURATION = 3000;
export const ACS_TOAST_ERROR_DURATION = 5000;
